import { useState, useEffect } from "react";
import { Col, Container, Row, Input, Label, Table } from "reactstrap";
import axios from "axios";
import { API_URL } from "../../../config";
import { toast } from "react-toastify";
import Correct from "../../../assets/image/Correct.svg";
// import Close from "../../../assets/image/Close.svg";
const Company = () => {
  const [search1, setSearch1] = useState("");
  const [search, setSearch] = useState("");
  const [selectedTable, setSelectedTable] = useState("company");
  const [selectedItems1, setSelectedItems1] = useState(["Dadar", "Thane"]);
  //const companies = ["Aaji Care", "McDonalds", "ICICI", "Godrej", "TATA Mahindra"];
  const companies1 = ["Thane", "Vashi", "Kurla", "NaviMumbai", "Dadar"];
  const [selectedItems, setSelectedItems] = useState(["Aaji Care", "ICICI"]);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default 10
  //const [filteredBranches, setFilteredBranches] = useState([]);
  const [selectedCompanyNames, setSelectedCompanyNames] = useState([]);
  const [searchCompany, setSearchCompany] = useState("");
  const [branches, setBranches] = useState([]);
  const [errorsbranch, setErrorsbranch] = useState({});
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentCompanies = companies.slice(indexOfFirstItem, indexOfLastItem);

  const [searchBranchId, setSearchBranchId] = useState("");
  const [selectedBranchIds, setSelectedBranchIds] = useState([]);
  const [allBranchIds, setAllBranchIds] = useState([]);

  const [filteredBranches, setFilteredBranches] = useState([]);
  const branchesToDisplay = branches.filter((branch) => {
    const matchesCompany =
      selectedCompanyNames.length === 0 ||
      selectedCompanyNames.includes(branch.company_name);

    const matchesBranch =
      selectedBranchIds.length === 0 ||
      selectedBranchIds.includes(branch.branch_id.toString());

    return matchesCompany && matchesBranch;
  });

  const totalPages = Math.ceil(companies.length / itemsPerPage);

  const currentBranches = branchesToDisplay.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPagess = Math.ceil(branches.length / itemsPerPage);

  // Filtered list
  const [selectedBranchLocations, setSelectedBranchLocations] = useState([]); // Dropdown filters
  // for listing all unique branch_ids

  //const [search1, setSearch1] = useState(""); // Search in dropdown

  const initialBranchFormData = {
    company_name: "",
    branch_id: "",
    branch_poc_name: "",
    poc_number: "",
    compliance_officer_id: "",
    email_id: "",
    status: 1,
    city: "",
    state: "",
    office_address: "",
    created_by: 1,
  };

  const initialCompanyFormData = {
    company_name: "",
    company_id: "",
    gst_number: "",
    office_address: "",
    point_contact_name: "",
    phone_number: "",
    cin_number: "",
    city: "",
    state: "",
  };

  const [formData, setFormData] = useState(initialBranchFormData);
  const [companyForm, setCompanyForm] = useState(initialCompanyFormData);
  const [companyErrors, setCompanyErrors] = useState({});

  const toggleBranchIdSelection = (id) => {
    setSelectedBranchIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    if (selectedBranchIds.length === 0) {
      setFilteredBranches(branches); // show all when nothing selected
    } else {
      const filtered = branches.filter((branch) =>
        selectedBranchIds.includes(branch.branch_id)
      );
      setFilteredBranches(filtered);
    }
  }, [selectedBranchIds, branches]);

  useEffect(() => {
    if (selectedBranch) {
      setFormData({
        company_name: selectedBranch.company_name || "",
        branch_id: selectedBranch.branch_id || "",
        branch_poc_name: selectedBranch.branch_poc_name || "",
        poc_number: selectedBranch.poc_number || "",
        compliance_officer_id: selectedBranch.compliance_officer_id || "",
        email_id: selectedBranch.email_id || "",
        city: selectedBranch.city || "",
        state: selectedBranch.state || "",
        office_address: selectedBranch.office_address || "",
        created_by: 2,
        status: selectedBranch.status ?? 1,
      });
    }
  }, [selectedBranch]);
  const validateCompanyForm = () => {
    const newErrors = {};

    const trimmedName = (companyForm.company_name || "").trim();
    const trimmedCompanyId = (companyForm.company_id || "").trim();
    const trimmedOfficeAddress = (companyForm.office_address || "").trim();
    const trimmedPocName = (companyForm.point_contact_name || "").trim();
    const trimmedCity = (companyForm.city || "").trim();
    const trimmedState = (companyForm.state || "").trim();
    const gstValue = (companyForm.gst_number || "").trim().toUpperCase();
    const cinValue = (companyForm.cin_number || "").trim().toUpperCase();
    const phoneValue = (companyForm.phone_number || "").trim();

    if (!trimmedName) newErrors.company_name = "Company name is required.";
    if (!trimmedCompanyId)
      newErrors.company_id = "Company ID is required.";
    if (!gstValue) {
      newErrors.gst_number = "GST number is required.";
    } else if (!/^[0-9A-Z]{15}$/.test(gstValue)) {
      newErrors.gst_number = "GST number should be 15 alphanumeric characters.";
    }

    if (!cinValue) {
      newErrors.cin_number = "CIN number is required.";
    } else if (!/^[A-Z0-9]{8,21}$/.test(cinValue)) {
      newErrors.cin_number = "CIN number should be 8-21 alphanumeric characters.";
    }

    if (!trimmedPocName)
      newErrors.point_contact_name = "POC name is required.";

    if (!phoneValue) {
      newErrors.phone_number = "POC number is required.";
    } else if (!/^[0-9]{10}$/.test(phoneValue)) {
      newErrors.phone_number = "Enter a valid 10 digit phone number.";
    }

    if (!trimmedCity) newErrors.city = "City is required.";
    if (!trimmedState) newErrors.state = "State is required.";
    if (!trimmedOfficeAddress)
      newErrors.office_address = "Office address is required.";

    setCompanyErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateForm = () => {
    const newErrors = {};

    const trimmedCompanyName = (formData.company_name || "").trim();
    const trimmedBranchId = (formData.branch_id || "").toString().trim();
    const trimmedEmail = (formData.email_id || "").trim();
    const trimmedBranchPocName = (formData.branch_poc_name || "").trim();
    const trimmedPocNumber = (formData.poc_number || "").trim();
    const trimmedCity = (formData.city || "").trim();
    const trimmedState = (formData.state || "").trim();
    const trimmedAddress = (formData.office_address || "").trim();

    if (!trimmedCompanyName)
      newErrors.company_name = "Company name is required.";
    if (!trimmedBranchId)
      newErrors.branch_id = "Branch ID is required.";
    if (!trimmedEmail) {
      newErrors.email_id = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(trimmedEmail)) {
      newErrors.email_id = "Enter a valid email address.";
    }

    if (!trimmedBranchPocName)
      newErrors.branch_poc_name = "POC name is required.";
    if (!trimmedPocNumber) {
      newErrors.poc_number = "POC number is required.";
    } else if (!/^[0-9]{10}$/.test(trimmedPocNumber)) {
      newErrors.poc_number = "Enter a valid 10 digit phone number.";
    }

    if (!trimmedCity) newErrors.city = "City is required.";
    if (!trimmedState) newErrors.state = "State is required.";
    if (!trimmedAddress)
      newErrors.office_address = "Office address is required.";

    setErrorsbranch(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (name === "poc_number") {
      updatedValue = value.replace(/[^0-9]/g, "");
    }

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    if (errorsbranch[name]) {
      setErrorsbranch((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleCompanyInputChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (name === "phone_number") {
      updatedValue = value.replace(/[^0-9]/g, "");
    } else if (name === "gst_number" || name === "cin_number") {
      updatedValue = value.toUpperCase();
    }

    setCompanyForm((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    if (companyErrors[name]) {
      setCompanyErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const openCompanyModal = () => {
    setCompanyForm({ ...initialCompanyFormData });
    setCompanyErrors({});
    setShowCreateCompanyModal(true);
  };

  const closeCompanyModal = () => {
    setShowCreateCompanyModal(false);
    setCompanyErrors({});
    setCompanyForm({ ...initialCompanyFormData });
  };

  const openBranchModal = () => {
    setFormData({ ...initialBranchFormData });
    setErrorsbranch({});
    setShowCreateBranchModal(true);
  };

  const closeBranchModal = () => {
    setShowCreateBranchModal(false);
    setErrorsbranch({});
    setFormData({ ...initialBranchFormData });
  };

  const handlebranchupdate = async (e) => {
    e.preventDefault();
    if (!selectedBranch?.id) {
      alert("Branch ID not found.");
      return;
    }

    try {
      await axios.put(
        `${API_URL}/auditor/branch/updateBranch/${selectedBranch.id}`,
        formData
      );
      fetchBranches();
      toast.success("Branch updated successfully!");
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Failed to update branch.");
    }
  };

  const handlebranchSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    try {
      const payload = {
        ...formData,
        company_name: (formData.company_name || "").trim(),
        branch_id: (formData.branch_id || "").toString().trim(),
        email_id: (formData.email_id || "").trim(),
        branch_poc_name: (formData.branch_poc_name || "").trim(),
        poc_number: (formData.poc_number || "").trim(),
        city: (formData.city || "").trim(),
        state: (formData.state || "").trim(),
        office_address: (formData.office_address || "").trim(),
      };
      const response = await axios.post(
        `${API_URL}/auditor/branch/createBranch/`,
        payload
      );
      console.log("Success:", response.data);
      toast.success("Branch created successfully!");
      fetchBranches();
      setFormData({ ...initialBranchFormData });
      setErrorsbranch({});
      closeBranchModal();
    } catch (err) {
      console.error("Error creating branch:", err);
      toast.error("Something went wrong!");
    }
  };
  const toggleCompanySelection = (companyName) => {
    setSelectedCompanyNames((prevSelected) => {
      const updated = prevSelected.includes(companyName)
        ? prevSelected.filter((name) => name !== companyName)
        : [...prevSelected, companyName];

      const filtered = branches.filter((branch) =>
        updated.includes(branch.company_name)
      );

      setFilteredBranches(filtered);
      return updated;
    });
  };

  const toggleSelection1 = (location) => {
    let updated = [...selectedBranchLocations];
    if (updated.includes(location)) {
      updated = updated.filter((item) => item !== location);
    } else {
      updated.push(location);
    }
    setSelectedBranchLocations(updated);
    applyBranchFilter(updated);
  };
  const applyBranchFilter = (selectedLocations) => {
    if (selectedLocations.length === 0) {
      setFilteredBranches(branches);
    } else {
      const filtered = branches.filter((branch) =>
        selectedLocations.includes(branch.city)
      );
      setFilteredBranches(filtered);
    }
  };
  // const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [showCreateCompanyModal, setShowCreateCompanyModal] = useState(false);
  const [showCreateBranchModal, setShowCreateBranchModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateCompanyForm()) {
      return;
    }

    const sanitizedCompanyData = {
      ...companyForm,
      company_name: (companyForm.company_name || "").trim(),
      company_id: (companyForm.company_id || "").trim(),
      gst_number: (companyForm.gst_number || "").trim().toUpperCase(),
      office_address: (companyForm.office_address || "").trim(),
      point_contact_name: (companyForm.point_contact_name || "").trim(),
      phone_number: (companyForm.phone_number || "").trim(),
      cin_number: (companyForm.cin_number || "").trim().toUpperCase(),
      city: (companyForm.city || "").trim(),
      state: (companyForm.state || "").trim(),
    };

    const formPayload = new FormData();
    Object.entries(sanitizedCompanyData).forEach(([key, value]) => {
      formPayload.append(key, value);
    });
    formPayload.append("assigned_auditor", 1);
    formPayload.append("status", 1);
    formPayload.append("created_by", 1);

    try {
      const response = await fetch(`${API_URL}/auditor/company/create`, {
        method: "POST",
        body: formPayload,
      });

      const result = await response.json();
      if (result.statusCode === 200) {
        fetchCompanies();
        fetchBranches();
        setCompanyForm({ ...initialCompanyFormData });
        setCompanyErrors({});
        closeCompanyModal();
        toast.success("Company created successfully");
      } else {
        toast.error(`Failed: ${result.message}`);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong!");
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData();
    const user = localStorage.getItem("user_id");
    // Append form fields
    formData.append("company_name", form.company_name.value);
    formData.append("company_id", selectedCompany?.company_id);
    formData.append("gst_number", form.gst_number.value);
    formData.append("office_address", form.office_address.value);
    formData.append("point_contact_name", form.point_contact_name.value);
    formData.append("phone_number", form.phone_number.value);
    formData.append("cin_number", form.cin_number.value);
    formData.append("city", form.city.value);
    formData.append("state", form.state.value);
    formData.append("assigned_auditor", 1); // or from form/props
    formData.append("status", 1); // default Active
    formData.append("updated_by", 1);
    formData.append("updated_by", user);
    // formData.append("date_of_mou", form.date_of_mou.value); // if included

    // const actsFile = form.acts_csv.files[0];
    // if (actsFile) {
    //   formData.append("acts", actsFile);
    // }

    try {
      const response = await fetch(
        `${API_URL}/auditor/company/updateCompany/${selectedCompany?.company_id}`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      if (result.statusCode === 200) {
        toast.success("Company updated successfully!");
        setShowModal3(false);
        fetchCompanies();
      } else {
        toast.error(`Failed: ${result.message}`);
      }
    } catch (err) {
      console.error("Update failed:", err);
      toast.error("Something went wrong!");
    }
  };

  const fetchCompanies = async () => {
    try {
      const res = await axios.get(`${API_URL}/auditor/company/companies`);
      setCompanies(res.data.data); // assuming your API response structure
    } catch (err) {
      console.error("Error fetching companies", err);
    }
  };

  // Fetch branches
  const fetchBranches = async () => {
    console.log("fetchBranches call");
    try {
      const res = await fetch(`${API_URL}/auditor/branch/getAllBranch`);
      const result = await res.json();

      if (Array.isArray(result.data)) {
        setBranches(result.data);
        setFilteredBranches(result.data);

        // Extract unique branch_ids
        const uniqueBranchIds = [
          ...new Set(result.data.map((b) => b.branch_id)),
        ];
        setAllBranchIds(uniqueBranchIds); // Make sure this state is defined
        return result.data;
      } else {
        console.error("Unexpected response:", result);
      }
    } catch (error) {
      console.error("Failed to fetch branches:", error);
    }
  };

  useEffect(() => {
    fetchBranches().then((data) => {
      console.log("Data", data);

      if (Array.isArray(data)) {
        setBranches(data);
        const uniqueBranchIds = [...new Set(data.map((b) => b.branch_id))];
        setAllBranchIds(uniqueBranchIds);
      } else {
        console.error("Invalid response format for branches:", data);
      }
    });
  }, []);

  useEffect(() => {
    fetchBranches();
  }, []);

  useEffect(() => {
    fetchCompanies();
    fetchBranches();
  }, []);
  return (
    <section className="lyt-section">
      <Container fluid className="typ-container">
        <div>
          <div className="d-flex justify-content-between align-items-center border-bottom py-2 px-3">
            <div className="d-flex gap-2">
              <button
                className={`border-0 bg-transparent px-2 fs-12 ${
                  selectedTable === "company"
                    ? "fw-bold border-bottom border-3 border-dark"
                    : ""
                }`}
                onClick={() => setSelectedTable("company")}
              >
                Company
              </button>
              <button
                className={`border-0 bg-transparent px-2 fs-12 ${
                  selectedTable === "branch"
                    ? "fw-bold border-bottom border-3 border-dark"
                    : ""
                }`}
                onClick={() => setSelectedTable("branch")}
              >
                Branch
              </button>
            </div>
            {selectedTable === "company" && (
              <div className="d-flex align-items-center gap-2">
                <div>
                  {/* <button
                    className="btn dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    Filter by City
                  </button> */}
                  <ul className="dropdown-menu p-2" style={{ width: "270px" }}>
                    <div className="border p-2 rounded mb-2">
                      <div>
                        {selectedBranchLocations.length > 0
                          ? selectedBranchLocations.map((item, index) => (
                              <span
                                key={index}
                                className="bg-dark text-white px-1 rounded me-1 fs-12"
                              >
                                {item}
                              </span>
                            ))
                          : "Select City"}
                      </div>
                    </div>
                    <li>
                      <input
                        type="text"
                        className="form-control fs-12"
                        placeholder="Search"
                        value={search1}
                        onChange={(e) => setSearch1(e.target.value)}
                      />
                    </li>
                    <div className="mt-2">
                      {[
                        ...new Set(
                          branches
                            .filter((b) =>
                              b.city
                                ?.toLowerCase()
                                .includes(search1.toLowerCase())
                            )
                            .map((b) => b.city)
                        ),
                      ].map((city) => (
                        <li
                          key={city}
                          className="form-check d-flex justify-content-between align-items-center py-1 border-bottom"
                        >
                          <label className="form-check-label flex-grow-1 fs-6">
                            {city}
                          </label>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedBranchLocations.includes(city)}
                            onChange={() => toggleSelection1(city)}
                          />
                        </li>
                      ))}
                    </div>
                  </ul>
                </div>

                <button
  className=" fs-12 create-company-btn"
  onClick={openCompanyModal}
>
  Create Company
</button>

                {/* Modal */}
                {showCreateCompanyModal && (
                  <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    role="dialog"
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                    }}
                  >
                    <div
                      className="modal-dialog modal-dialog-centered"
                      role="document"
                    >
                      <div
                        className="modal-content p-4"
                        style={{ borderRadius: "12px" }}
                      >
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h5 className="modal-title fw-bold fs-12">
                            CREATE COMPANY
                          </h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={closeCompanyModal}
                          />
                        </div>
                        {/* Form */}
                        <form
                          onSubmit={handleSubmit} // Make sure to implement this handler
                          encType="multipart/form-data"
                        >
                          <div className="mb-3">
                            <label className="fs-12">Company Name</label>
                            <input
                              name="company_name"
                              className="form-control"
                              placeholder="Enter here"
                              value={companyForm.company_name}
                              onChange={handleCompanyInputChange}
                            />
                            {companyErrors.company_name && (
                              <small className="text-danger">
                                {companyErrors.company_name}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <label className="fs-12">Company Id</label>
                            <input
                              name="company_id"
                              className="form-control"
                              placeholder="Enter here"
                              value={companyForm.company_id}
                              onChange={handleCompanyInputChange}
                            />
                            {companyErrors.company_id && (
                              <small className="text-danger">
                                {companyErrors.company_id}
                              </small>
                            )}
                          </div>

                          <div className="row">
                            <div className="col">
                              <label className="fs-12">CIN Number</label>
                              <input
                                name="cin_number"
                                className="form-control"
                                placeholder="Enter here"
                                value={companyForm.cin_number}
                                onChange={handleCompanyInputChange}
                              />
                              {companyErrors.cin_number && (
                                <small className="text-danger">
                                  {companyErrors.cin_number}
                                </small>
                              )}
                            </div>
                            <div className="col">
                              <label className="fs-12">GST Number</label>
                              <input
                                name="gst_number"
                                className="form-control"
                                placeholder="Enter here"
                                value={companyForm.gst_number}
                                onChange={handleCompanyInputChange}
                              />
                              {companyErrors.gst_number && (
                                <small className="text-danger">
                                  {companyErrors.gst_number}
                                </small>
                              )}
                            </div>
                          </div>

                          <div className="row mt-3">
                            <div className="col">
                              <label className="fs-12">POC Name</label>
                              <input
                                name="point_contact_name"
                                className="form-control"
                                placeholder="Enter here"
                                value={companyForm.point_contact_name}
                                onChange={handleCompanyInputChange}
                              />
                              {companyErrors.point_contact_name && (
                                <small className="text-danger">
                                  {companyErrors.point_contact_name}
                                </small>
                              )}
                            </div>
                            <div className="col">
                              <label className="fs-12">POC Number</label>
                              <input
                                name="phone_number"
                                className="form-control"
                                placeholder="Enter here"
                                value={companyForm.phone_number}
                                onChange={handleCompanyInputChange}
                                maxLength={10}
                                inputMode="numeric"
                              />
                              {companyErrors.phone_number && (
                                <small className="text-danger">
                                  {companyErrors.phone_number}
                                </small>
                              )}
                            </div>
                          </div>

                          <div className="row mt-3">
                            <div className="col">
                              <label className="fs-12">City</label>
                              <input
                                name="city"
                                className="form-control"
                                placeholder="Enter here"
                                value={companyForm.city}
                                onChange={handleCompanyInputChange}
                              />
                              {companyErrors.city && (
                                <small className="text-danger">
                                  {companyErrors.city}
                                </small>
                              )}
                            </div>
                            <div className="col">
                              <label className="fs-12">State</label>
                              <input
                                name="state"
                                className="form-control"
                                placeholder="Enter here"
                                value={companyForm.state}
                                onChange={handleCompanyInputChange}
                              />
                              {companyErrors.state && (
                                <small className="text-danger">
                                  {companyErrors.state}
                                </small>
                              )}
                            </div>
                          </div>

                          <div className="mt-3">
                            <label className="fs-12">Office Address</label>
                            <input
                              name="office_address"
                              className="form-control"
                              placeholder="Enter here"
                              value={companyForm.office_address}
                              onChange={handleCompanyInputChange}
                            />
                            {companyErrors.office_address && (
                              <small className="text-danger">
                                {companyErrors.office_address}
                              </small>
                            )}
                          </div>

                          <div className="text-end mt-4">
                            <button
                              type="submit"
                              className="btn fs-12"
                              style={{
                                backgroundColor: "#1F1F23",
                                color: "#fff",
                                padding: "6px 14px",
                                borderRadius: "8px",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              Create Company
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            {selectedTable === "branch" && (
              <div className="d-flex align-items-center gap-2">
                <div>
                  <button
                    className="btn dropdown-toggle fs-12"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{
                      border: "1px solid #E4E4E7",
                      backgroundColor: "#FFFFFF",
                      color: "#1F1F23",
                      borderRadius: "5px",
                      padding: "6px 14px",
                    
                fontSize:"12px",
                      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    }}
                  >
                    Select Branch ID
                  </button>

                  <ul className="dropdown-menu p-2" style={{ width: "270px" }}>
                    {/* Selected Tags Preview */}
                    <div className="border p-2 rounded mb-2">
                      <div>
                        {selectedBranchIds.length > 0 ? (
                          selectedBranchIds.map((item, index) => (
                            <span
                              key={index}
                              className="bg-dark text-white px-1 rounded me-1"
                            >
                              {item}
                            </span>
                          ))
                        ) : (
                          <span className="text-muted fs-12">Select ID</span>
                        )}
                      </div>
                    </div>

                    {/* Search Input */}
                    <li>
                      <input
                        type="text"
                        className="form-control fs-12"
                        placeholder="Search Branch ID"
                        value={search1}
                        onChange={(e) => setSearch1(e.target.value)}
                      />
                    </li>

                    {/* List with Checkboxes */}
                    <div
                      className="mt-2 w-full"
                      style={{ maxHeight: "200px", overflowY: "auto" }}
                    >
                      {allBranchIds
                        .filter((id) =>
                          id.toLowerCase().includes(search1.toLowerCase())
                        )
                        .map((id) => (
                          <li
                            key={id}
                            className="form-check d-flex justify-content-between align-items-center py-1 border-bottom"
                          >
                            <label className="form-check-label flex-grow-1 fs-12">
                              {id}
                            </label>
                            <input
                              className="form-check-input fs-12"
                              type="checkbox"
                              checked={selectedBranchIds.includes(id)}
                              onChange={() => toggleBranchIdSelection(id)}
                            />
                          </li>
                        ))}
                    </div>

                    {/* Clear Button */}
                    <div className="mt-2 text-end">
                      <button
                        className="btn btn-sm btn-outline-secondary fs-12"
                        onClick={() => setSelectedBranchIds([])}
                      >
                        Clear All
                      </button>
                    </div>
                  </ul>
                </div>

                <div className="dropdown">
                  <button
                    className="btn dropdown-toggle fs-12"
                    type="button"
                    data-bs-toggle="dropdown"
                    style={{
                      border: "1px solid #E4E4E7",
                      backgroundColor: "#FFFFFF",
                      color: "#1F1F23",
                      borderRadius: "5px",
                      padding: "6px 14px",
              fontSize:"12px",
                      fontWeight: "500",
                      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    }}
                  >
                    Select Company Name
                  </button>
                  <ul className="dropdown-menu p-2" style={{ width: "270px" }}>
                    <div className="border p-2 rounded mb-2">
                      <div>
                        {selectedCompanyNames.length > 0
                          ? selectedCompanyNames.map((item, index) => (
                              <span
                                key={index}
                                className="bg-dark text-white px-1 rounded me-1 fs-12"
                              >
                                {item}
                              </span>
                            ))
                          : "Select Name"}
                      </div>
                    </div>
                    <li>
                      <input
                        type="text"
                        className="form-control fs-12"
                        placeholder="Search"
                        value={searchCompany}
                        onChange={(e) => setSearchCompany(e.target.value)}
                      />
                    </li>
                    <div
                      className="mt-2 w-full"
                      style={{ maxHeight: "200px", overflowY: "auto" }}
                    >
                      {companies
                        .filter((c) =>
                          c.company_name
                            .toLowerCase()
                            .includes(searchCompany.toLowerCase())
                        )
                        .map((company) => (
                          <li
                            className="form-check d-flex justify-content-between align-items-center py-1 border-bottom"
                            key={company.id}
                          >
                            <label className="form-check-label flex-grow-1 fs-12">
                              {company.company_name}
                            </label>
                            <input
                              className="form-check-input fs-12"
                              type="checkbox"
                              checked={selectedCompanyNames.includes(
                                company.company_name
                              )}
                              onChange={() =>
                                toggleCompanySelection(company.company_name)
                              }
                            />
                          </li>
                        ))}
                      {companies.length > 0 && (
                        <div className="text-center mt-2">
                          <button
                            className="btn btn-sm btn-outline-danger fs-12"
                            onClick={() => {
                              setSelectedCompanyNames([]);
                              setFilteredBranches([]);
                            }}
                          >
                            Clear Filter
                          </button>
                        </div>
                      )}
                    </div>
                  </ul>
                </div>
                <button
                  className="create-company-btn "
                 
                  onClick={openBranchModal}
                >
                  Create Branch
                </button>
                {/* Modal */}
                {showCreateBranchModal && (
                  <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                  >
                    <div
                      className="modal-dialog modal-dialog-centered"
                      style={{ maxWidth: "500px" }}
                    >
                      <div
                        className="modal-content p-4"
                        style={{ borderRadius: "12px" }}
                      >
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h5 className="modal-title fw-bold fs-12" >CREATE BRANCH</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={closeBranchModal}
                          />
                        </div>
                        <form onSubmit={handlebranchSubmit}>
                          <div className="mb-3">
                            <label className="fs-12">Company Name</label>
                            <select
                              className="form-control"
                              name="company_name"
                              onChange={handleChange}
                              value={formData.company_name}
                            >
                              <option className="fs-12" value="" disabled hidden>
                                Select
                              </option>
                              {companies.map((company) => (
                                <option
                                  key={company.id}
                                  value={company.company_name}
                                >
                                  {company.company_name}
                                </option>
                              ))}
                            </select>
                            {errorsbranch.company_name && (
                              <small className="text-danger">
                                {errorsbranch.company_name}
                              </small>
                            )}
                          </div>

                          <div className="row mb-3">
                            <div className="col">
                              <label className="fs-12">Branch ID</label>
                              <input
                                className="form-control"
                                placeholder="Enter here"
                                name="branch_id"
                                onChange={handleChange}
                                value={formData.branch_id}
                              />
                              {errorsbranch.branch_id && (
                                <small className="text-danger">
                                  {errorsbranch.branch_id}
                                </small>
                              )}
                            </div>
                            <div className="col">
                              <label className="fs-12">Email</label>
                              <input
                                className="form-control"
                                placeholder="Enter here"
                                name="email_id"
                                onChange={handleChange}
                                value={formData.email_id}
                              />
                              {errorsbranch.email_id && (
                                <small className="text-danger">
                                  {errorsbranch.email_id}
                                </small>
                              )}
                            </div>
                          </div>

                          <div className="row mb-3">
                            <div className="col">
                              <label className="fs-12"> Branch POC Name</label>
                              <input
                                className="form-control"
                                placeholder="Enter here"
                                name="branch_poc_name"
                                onChange={handleChange}
                                value={formData.branch_poc_name}
                              />
                              {errorsbranch.branch_poc_name && (
                                <small className="text-danger">
                                  {errorsbranch.branch_poc_name}
                                </small>
                              )}
                            </div>
                            <div className="col">
                              <label className="fs-12">Branch POC Num</label>
                              <input
                                className="form-control"
                                placeholder="Enter here"
                                name="poc_number"
                                onChange={handleChange}
                                value={formData.poc_number}
                                maxLength={10}
                                inputMode="numeric"
                              />
                              {errorsbranch.poc_number && (
                                <small className="text-danger">
                                  {errorsbranch.poc_number}
                                </small>
                              )}
                            </div>
                          </div>

                          <div className="row mb-3">
                            <div className="col">
                              <label className="fs-12">City</label>
                              <input
                                className="form-control"
                                placeholder="Enter here"
                                name="city"
                                onChange={handleChange}
                                value={formData.city}
                              />
                              {errorsbranch.city && (
                                <small className="text-danger">
                                  {errorsbranch.city}
                                </small>
                              )}
                            </div>
                            <div className="col">
                              <label className="fs-12">State</label>
                              <input
                                className="form-control"
                                placeholder="Enter here"
                                name="state"
                                onChange={handleChange}
                                value={formData.state}
                              />
                              {errorsbranch.state && (
                                <small className="text-danger">
                                  {errorsbranch.state}
                                </small>
                              )}
                            </div>
                          </div>

                          <div className="mb-3">
                            <label className="fs-12">Branch Address</label>
                            <input
                              className="form-control"
                              placeholder="Enter here"
                              name="office_address"
                              onChange={handleChange}
                              value={formData.office_address}
                            />
                            {errorsbranch.office_address && (
                              <small className="text-danger">
                                {errorsbranch.office_address}
                              </small>
                            )}
                          </div>

                          {/* <div className="mb-3">
                            <label>Compliance Officer ID</label>
                            <input
                              className="form-control"
                              placeholder="Enter here"
                              name="compliance_officer_id"
                              onChange={handleChange}
                              value={formData.compliance_officer_id}
                            />
                            {errorsbranch.compliance_officer_id && (
                              <small className="text-danger">
                                {errorsbranch.compliance_officer_id}
                              </small>
                            )}
                          </div> */}

                          <div className="text-end">
                            <button
                              type="submit"
                              className="btn fs-12"
                              style={{
                                backgroundColor: "#1F1F23",
                                color: "#fff",
                                padding: "6px 14px",
                                borderRadius: "8px",
                                fontSize:"12px",
                              
                                fontWeight: "500",
                              }}
                            >
                              Create Branch
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          {selectedTable === "company" && (
            <div className="mt-4">
              <div className="">
                <div className="card-body p-0">
                  <div className="table-responsive">
                       <div className="table-scroll">
                    <table className="table table-hover align-middle mt-0 rounded vertical-border">
                      <thead className="bg-light text-nowrap fs-12 table-color">
                        <tr>
                          {/* <th>
                            <input type="checkbox" />
                          </th> */}
                          <th>Sr No</th>
                          <th>Name</th>
                          <th>User Id</th>
                          <th>User Type</th>
                          <th>Phone No</th>
                          <th>Email</th>
                          <th>Address</th>
                          <th>Assigned Auditor</th>
                          <th>Status</th>
                          <th>Action</th>
                          <th>Delete Action</th>
                        </tr>
                      </thead>
                      <tbody className="fs-12 table-color">
                        {currentCompanies.map((company, i) => (
                          <tr key={company.id}>
                            {/* <td>
                              <input type="checkbox" />
                            </td> */}
                            <td>{indexOfFirstItem + i + 1}</td>
                            <td>{company.company_name}</td>
                            <td>{company.company_id}</td>
                            <td>Company</td>
                            <td>{company.phone_number}</td>
                            <td>-</td> {/* Email not present in API */}
                            <td>{company.office_address}</td>
                            <td>{company.assigned_auditor}</td>
                            <td>
                              {company.status === 0 ? (
                                <button
                                  className="d-flex align-items-center border-0"
                                  style={{
                                    backgroundColor: "#FFF3CD",
                                    color: "#FFC107",
                                    borderRadius: "20px",
                                    padding: "6px 12px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    display: "flex",
                                    gap: "6px",
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#FFC107"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 1.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13zm0 1a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11z" />
                                    <path d="M7.5 4.5h1v4h-1v-4zM7.5 9h1v1h-1V9z" />
                                  </svg>
                                  Pending
                                </button>
                              ) : (
                                <button
                                  className="d-flex align-items-center border-0"
                                  style={{
                                    backgroundColor: "#E6FAF2",
                                    color: "#1DBF73",
                                    borderRadius: "20px",
                                    padding: "6px 12px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    display: "flex",
                                    gap: "6px",
                                  }}
                                >
                                    <img src={Correct} alt="active" />
                                  Active
                                </button>
                              )}
                            </td>
                            <td>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setSelectedCompany(company);
                                  setShowModal3(true);
                                }}
                              >
                                view & edit
                              </a>
                            </td>
                            <td>
                              <a
                                href="#"
                                onClick={async (e) => {
                                  e.preventDefault();
                                  if (
                                    window.confirm(
                                      "Delete this company? All its branches, compliances, related legislation, and reports will be removed."
                                    )
                                  ) {
                                    try {
                                      const response = await fetch(
                                        `${API_URL}/auditor/company/deleteCompany/${company.id}`,
                                        {
                                          method: "GET",
                                        }
                                      );

                                      const result = await response.json();
                                      if (response.ok) {
                                        toast.success(
                                          "Company deleted successfully"
                                        );
                                        fetchCompanies();
                                        fetchBranches();
                                      } else {
                                        toast.error(
                                          `Failed: ${result.message}`
                                        );
                                      }
                                    } catch (error) {
                                      console.error(
                                        "Error deleting company:",
                                        error
                                      );
                                      toast.error(
                                        "Something went wrong while deleting the company"
                                      );
                                    }
                                  }
                                }}
                              >
                                Delete
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    </div>
                    {showModal3 && (
                      <div
                        className="modal fade show d-block"
                        tabIndex="-1"
                        role="dialog"
                        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                      >
                        <div
                          className="modal-dialog modal-dialog-centered"
                          role="document"
                        >
                          <div
                            className="modal-content p-4"
                            style={{ borderRadius: "12px" }}
                          >
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h5 className="modal-title fw-bold fs-12">
                                EDIT COMPANY
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowModal3(false)}
                              />
                            </div>
                            <form onSubmit={handleUpdate}>
                              {/* Visible and disabled Company ID */}
                              <div className="mb-3">
                                <label className="fs-12">Company ID</label>
                                <input
                                  className="form-control"
                                  value={selectedCompany?.id}
                                  disabled
                                />
                                {/* Hidden field to ensure value is submitted */}
                                <input
                                  hidden
                                  disabled
                                  value={selectedCompany?.company_id || ""}
                                />
                              </div>

                              <div className="mb-3">
                                <label className="fs-12">Company Name</label>
                                <input
                                  name="company_name"
                                  className="form-control"
                                  placeholder="Enter here"
                                  defaultValue={selectedCompany?.company_name}
                                />
                              </div>

                              <div className="row">
                                <div className="col">
                                  <label className="fs-12">CIN Num</label>
                                  <input
                                    name="cin_number"
                                    className="form-control"
                                    placeholder="Enter here"
                                    defaultValue={selectedCompany?.cin_number}
                                  />
                                </div>
                                <div className="col">
                                  <label className="fs-12">GST Num</label>
                                  <input
                                    name="gst_number"
                                    className="form-control"
                                    placeholder="Enter here"
                                    defaultValue={selectedCompany?.gst_number}
                                  />
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col">
                                  <label className="fs-12">POC Name</label>
                                  <input
                                    name="point_contact_name"
                                    className="form-control"
                                    placeholder="Enter here"
                                    defaultValue={
                                      selectedCompany?.point_contact_name
                                    }
                                  />
                                </div>
                                <div className="col">
                                  <label className="fs-12">POC Num</label>
                                  <input
                                    name="phone_number"
                                    className="form-control"
                                    placeholder="Enter here"
                                    defaultValue={selectedCompany?.phone_number}
                                  />
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col">
                                  <label className="fs-12">City</label>
                                  <input
                                    name="city"
                                    className="form-control"
                                    placeholder="Enter here"
                                    defaultValue={selectedCompany?.city}
                                  />
                                </div>
                                <div className="col">
                                  <label className="fs-12">State</label>
                                  <input
                                    name="state"
                                    className="form-control"
                                    placeholder="Enter here"
                                    defaultValue={selectedCompany?.state}
                                  />
                                </div>
                              </div>
                              <div className="mt-3">
                                <label className="fs-12">Office Address</label>
                                <input
                                  name="office_address"
                                  className="form-control"
                                  placeholder="Enter here"
                                  defaultValue={selectedCompany?.office_address}
                                />
                              </div>
                              <div className="text-end mt-4">
                                <button
                                  type="submit"
                                  className="btn fs-12"
                                  style={{
                                    backgroundColor: "#1F1F23",
                                    color: "#fff",
                                    padding: "6px 14px",
                                    borderRadius: "8px",
                             
                                    fontWeight: "500",
                                  }}
                                >
                                  Save Changes
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Branch Table */}
          {selectedTable === "branch" && (
            <div className="mt-4">
              <div className="">
                <div className="card-body p-0">
                  <div className="table-responsive">
                       <div className="table-scroll">
                    <table className="table table-hover align-middle mt-0 rounded vertical-border">
                      <thead className="bg-light text-nowrap fs-12 table-color">
                        <tr>
                          
                          <th>Sr No</th>
                          <th>Company Name</th>
                          <th>Branch ID</th>
                          <th>POC Name</th>
                          <th>POC NO</th>

                          <th>Status</th>
                          <th>Action</th>
                          <th>Delete Action</th>
                        </tr>
                      </thead>
                      <tbody className="fs-12 table-color">
                        {currentBranches.map((branch, i) => (
                          <tr key={branch.id}>
                            
                            <td>{indexOfFirstItem + i + 1}</td>
                            <td>{branch.company_name}</td>
                            <td>{branch.branch_id}</td>
                            <td>{branch.branch_poc_name}</td>
                            <td>{branch.poc_number}</td>

                            <td>
                              {branch.status === 0 ? (
                                <button
                                  className="d-flex align-items-center border-0"
                                  style={{
                                    backgroundColor: "#FFF3CD",
                                    color: "#FFC107",
                                    borderRadius: "20px",
                                    padding: "6px 12px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    display: "flex",
                                    gap: "6px",
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#FFC107"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 1.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13zm0 1a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11z" />
                                    <path d="M7.5 4.5h1v4h-1v-4zM7.5 9h1v1h-1V9z" />
                                  </svg>
                                  Pending
                                </button>
                              ) : (
                                <button
                                  className="d-flex align-items-center border-0"
                                  style={{
                                    backgroundColor: "#E6FAF2",
                                    color: "#1DBF73",
                                    borderRadius: "20px",
                                    padding: "6px 12px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    display: "flex",
                                    gap: "6px",
                                  }}
                                >
                                  <img src={Correct} alt="active" />
                                  Active
                                </button>
                              )}
                            </td>
                            <td>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setSelectedBranch(branch);
                                  setShowModal4(true);
                                }}
                              >
                                view & edit
                              </a>
                            </td>
                            <td>
                              <a
                                href="#"
                                onClick={async (e) => {
                                  e.preventDefault();
                                  if (
                                    window.confirm(
                                      "Delete this branch? All compliances, legislation, and reports linked to this branch will be removed."
                                    )
                                  ) {
                                    try {
                                      const response = await fetch(
                                        `${API_URL}/auditor/branch/deleteBranch/${branch.id}`,
                                        {
                                          method: "GET",
                                        }
                                      );

                                      const result = await response.json();
                                      if (response.ok) {
                                        toast.success(
                                          "Branch deleted successfully"
                                        );
                                        fetchBranches(); // Refresh the list
                                      } else {
                                        toast.error(
                                          `Failed: ${result.message}`
                                        );
                                      }
                                    } catch (error) {
                                      console.error(
                                        "Error deleting branch:",
                                        error
                                      );
                                      toast.error(
                                        "Something went wrong while deleting the branch"
                                      );
                                    }
                                  }
                                }}
                              >
                                Delete
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    </div>
                    {showModal4 && (
                      <div
                        className="modal fade show d-block"
                        tabIndex="-1"
                        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                      >
                        <div
                          className="modal-dialog modal-dialog-centered"
                          style={{ maxWidth: "500px" }}
                        >
                          <div
                            className="modal-content p-4"
                            style={{ borderRadius: "12px" }}
                          >
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h5 className="modal-title fw-bold fs-12">
                                EDIT BRANCH
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowModal4(false)}
                              />
                            </div>
                            <form onSubmit={handlebranchupdate}>
                              <div className="mb-3">
                                <label className="fs-12">Company Name</label>
                                <input
                                  className="form-control"
                                  placeholder="Enter here"
                                  disabled
                                  name="company_name"
                                  value={formData.company_name}
                                />
                              </div>
                              <div className="row mb-3">
                                <div className="col">
                                  <label className="fs-12">Branch ID</label>
                                  <input
                                    className="form-control"
                                    placeholder="Enter here"
                                    disabled
                                    name="branch_id"
                                    value={formData.branch_id}
                                  />
                                </div>
                                <div className="col">
                                  <label className="fs-12">Email</label>
                                  <input
                                    className="form-control"
                                    placeholder="Enter here"
                                    name="email_id"
                                    value={formData.email_id}
                                    onChange={handleChange}
                                  />
                                </div>
                              </div>
                              <div className="row mb-3">
                                <div className="col">
                                  <label className="fs-12">Branch POC Name</label>
                                  <input
                                    className="form-control"
                                    placeholder="Enter here"
                                    name="branch_poc_name"
                                    value={formData.branch_poc_name}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div className="col">
                                  <label className="fs-12">Branch POC Num</label>
                                  <input
                                    className="form-control"
                                    placeholder="Enter here"
                                    name="poc_number"
                                    value={formData.poc_number}
                                    onChange={handleChange}
                                  />
                                </div>
                              </div>

                              <div className="mb-3">
                                <label className="fs-12">Branch Address</label>
                                <input
                                  className="form-control"
                                  placeholder="Enter here"
                                  name="office_address"
                                  value={formData.office_address}
                                  onChange={handleChange}
                                />
                              </div>

                              {/* <div className="mb-3">
                                <label>Status</label>
                                <select
                                  className="form-control"
                                  name="status"
                                  value={formData.status}
                                  onChange={handleChange}
                                >
                                  <option value={1}>Active</option>
                                  <option value={0}>Inactive</option>
                                </select>
                              </div> */}

                              <div className="text-end">
                                <button
                                  type="submit"
                                  className="btn fs-12"
                                  style={{
                                    backgroundColor: "#1F1F23",
                                    color: "#fff",
                                    padding: "6px 14px",
                                    borderRadius: "8px",
                       
                                    fontWeight: "500",
                                  }}
                                >
                                  Save Changes
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="d-flex justify-content-between align-items-center mt-4">
            {/* Total Page Dropdown */}
            <div>
              <select
                className="form-select form-select-sm w-auto"
                onChange={(e) => {
                  setCurrentPage(1);
                }}
              >
                <option className="fs-12">{totalPages} Pages</option>
              </select>
            </div>

            {/* Pagination Controls */}
            <nav>
              <ul className="pagination mb-0 d-flex align-items-center gap-2">
                {/* Previous */}
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <a
                    className="page-link text-dark border-0 bg-transparent fs-12"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (currentPage > 1) setCurrentPage(currentPage - 1);
                    }}
                  >
                    Previous
                  </a>
                </li>

                {/* First Page */}
                {currentPage > 3 && (
                  <>
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "active" : ""
                      }`}
                    >
                      <button
                       
                        className={`page-link fw-bold rounded-circle border-0 ${
                          currentPage === 1
                            ? "bg-dark text-white rounded-circle"
                            : "bg-transparent text-dark"
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          setCurrentPage(1);
                        }}
                      >
                        1
                      </button>
                    </li>
                    <li className="page-item disabled">
                      <span className="page-link text-dark border-0 bg-transparent">
                        ...
                      </span>
                    </li>
                  </>
                )}

                {/* Page Range: currentPage ±2 */}
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter(
                    (page) =>
                      page === 1 ||
                      page === totalPages ||
                      (page >= currentPage - 2 && page <= currentPage + 2)
                  )
                  .map((page) => (
                    <li
                      key={page}
                      className={`page-item ${
                        currentPage === page ? "active" : ""
                      }`}
                    >
                      <a
                        href="#"
                        className={`page-link ${
                          currentPage === page
                            ? "d-flex align-items-center justify-content-center fw-bold rounded-circle bg-dark text-white border-0"
                            : "text-dark border-0 bg-transparent"
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          setCurrentPage(page);
                        }}
                         style={{
                        width: "36px",
                        height: "36px",
                        padding: 0,
                        lineHeight: "36px",
                        textAlign: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      >
                        {page}
                      </a>
                    </li>
                  ))}

                {/* Last Page Ellipsis */}
                {currentPage < totalPages - 2 && (
                  <>
                    <li className="page-item disabled">
                      <span className="page-link text-dark border-0 bg-transparent">
                        ...
                      </span>
                    </li>
                    <li className="page-item">
                      <a
                        className="page-link text-dark border-0 bg-transparent fs-12"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setCurrentPage(totalPages);
                        }}
                      >
                        {totalPages}
                      </a>
                    </li>
                  </>
                )}

                {/* Next */}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <a
                    className="page-link text-dark border-0 bg-transparent fs-12"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (currentPage < totalPages)
                        setCurrentPage(currentPage + 1);
                    }}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </Container>
    </section>
  );
};
export default Company;
